import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, CalendarCheck } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { useLanguage } from "../i18n";

const NAV = [
    { key: "home", to: "/" },
    { key: "about", to: "/about" },
    { key: "conditions", to: "/conditions" },
    { key: "treatments", to: "/treatments" },
    { key: "patient_education", to: "/patient-education" },
    { key: "research", to: "/research" },
    { key: "contact", to: "/contact" },
];

export default function Header() {
    const [open, setOpen] = useState(false);
    const { t } = useLanguage();
    const navigate = useNavigate();

    return (
        <header className="sticky top-0 z-50 border-b border-border bg-white/95 backdrop-blur-md" data-testid="site-header">
            <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 lg:px-10">
                <Link to="/" className="group" data-testid="header-logo-link">
                    <span className="font-display text-lg font-semibold tracking-tight text-navy group-hover:text-accent transition-colors duration-300">
                        Dr. Krishnakanth AVB
                    </span>
                    <span className="block font-mono-label text-[0.62rem] text-steel">Consultant Urologist</span>
                </Link>

                <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
                    {NAV.map((n) => (
                        <NavLink key={n.key} to={n.to} end={n.to === "/"} data-testid={`nav-${n.key.replace(/_/g, "-")}`}
                            className={({ isActive }) =>
                                `text-[0.83rem] font-medium tracking-wide transition-colors duration-200 ${isActive ? "text-accent" : "text-steel hover:text-navy"}`}>
                            {t(n.key)}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden lg:flex items-center gap-4">
                    <button data-testid="header-book-appointment-btn" onClick={() => navigate("/appointment")}
                        className="inline-flex items-center gap-2 rounded-full bg-navy px-5 py-2.5 text-[0.83rem] font-semibold text-white transition-all duration-300 hover:bg-accent hover:shadow-md">
                        <CalendarCheck className="h-4 w-4" aria-hidden="true" />
                        {t("book_appointment")}
                    </button>
                </div>

                <div className="flex lg:hidden items-center gap-3">
                    <Sheet open={open} onOpenChange={setOpen}>
                        <SheetTrigger asChild>
                            <button data-testid="mobile-menu-btn" aria-label="Open menu"
                                className="rounded-md border border-border p-2 text-navy">
                                <Menu className="h-5 w-5" />
                            </button>
                        </SheetTrigger>
                        <SheetContent side="right" className="w-[300px] bg-white" data-testid="mobile-menu">
                            <div className="mt-8 flex flex-col gap-1">
                                {NAV.map((n) => (
                                    <NavLink key={n.key} to={n.to} end={n.to === "/"} onClick={() => setOpen(false)}
                                        data-testid={`mobile-nav-${n.key.replace(/_/g, "-")}`}
                                        className={({ isActive }) =>
                                            `rounded-lg px-4 py-3 text-base font-medium transition-colors ${isActive ? "bg-mist text-accent" : "text-navy hover:bg-mist"}`}>
                                        {t(n.key)}
                                    </NavLink>
                                ))}
                                <button data-testid="mobile-book-appointment-btn"
                                    onClick={() => { setOpen(false); navigate("/appointment"); }}
                                    className="mt-4 inline-flex items-center justify-center gap-2 rounded-full bg-navy px-5 py-3.5 text-sm font-semibold text-white">
                                    <CalendarCheck className="h-4 w-4" aria-hidden="true" />
                                    {t("book_appointment")}
                                </button>
                            </div>
                        </SheetContent>
                    </Sheet>
                </div>
            </div>
        </header>
    );
}
